
import { CheckCircle, AlertCircle } from "lucide-react";
import { CalendarProvider } from "@/services/calendarService";

interface CalendarConnectionStatusProps {
  hasCalendar: boolean;
  isChecking: boolean;
  hasConflict: boolean;
  connectedProviders: CalendarProvider[];
}

const CalendarConnectionStatus = ({
  hasCalendar,
  isChecking,
  hasConflict,
  connectedProviders
}: CalendarConnectionStatusProps) => {
  if (!hasCalendar) return null;
  
  return (
    <>
      <div className="text-sm flex items-center mt-2">
        {isChecking ? (
          <span className="text-muted-foreground">Checking availability...</span>
        ) : hasConflict ? (
          <>
            <AlertCircle className="h-4 w-4 text-orange-500 mr-1" />
            <span className="text-orange-500">Potential calendar conflict detected</span>
          </>
        ) : (
          <>
            <CheckCircle className="h-4 w-4 text-green-500 mr-1" />
            <span className="text-green-500">Time slot available</span>
          </>
        )}
      </div>
      
      <div className="text-sm text-muted-foreground">
        Connected to: {connectedProviders.map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(', ')} Calendar
      </div>
    </>
  );
};

export default CalendarConnectionStatus;
